/* IBM Confidential‌ - OCO Source Materials‌ - (C) COPYRIGHT IBM CORP. 2021-2022 - The source code for this program is not published or otherwise‌ divested of its trade secrets, irrespective of what has been‌ deposited with the U.S. Copyright Office. */

import { AppMsg } from "../utils";

export const AuthenticationService = {
    login,
    logout,
    changePassword
};

function login(username, password, loginObj) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ userName: username, password: password})
    };

    //Handle Authentication END-point URL
    let authenticationUrl = _handleAuthenticationUrl(loginObj);
   
    return fetch(authenticationUrl, requestOptions)
        .then(handleLoginResponse);
}

function _handleAuthenticationUrl(loginObj) {
    if (loginObj.isTririgaUX) {
        return '../../p/websignon/signon';
    } else if (loginObj.isAdmin) {
        return '../../p/websignon/tririga-admin-login' +
            '?screenWidth='+loginObj.screenWidth+
            '&screenHeight='+loginObj.screenHeight+
            '&contentType='+loginObj.contentType+
            '&languageId='+loginObj.languageId
    } else {
        let loginUrl = '../../p/websignon/tririga-login' +
            '?screenWidth='+loginObj.screenWidth+
            '&screenHeight='+loginObj.screenHeight+
            '&screenDPI='+loginObj.screenDPI+
            '&contentType='+loginObj.contentType+
            '&languageId='+loginObj.languageId+
            '&ieFlag='+loginObj.ieFlag+
            '&ExtReqURL='+loginObj.ExtReqURL;
        if (loginObj.state && loginObj.state != null && loginObj.state.length > 0) {
            loginUrl = loginUrl + '&state='+loginObj.state;
        }
        return loginUrl;
    }
}

function logout() {
    // remove user from local storage to log user out
    localStorage.removeItem('user');
}

function handleLoginResponse(response) {
    if (!response.ok) {
        // auto logout if response failed
        logout();
        if (response.status === 401) {
          // 401 indicates login error or pwd change required
          
          return response.text().then(text => {
              return text.includes('Password Change Needed') ? 
                Promise.reject(AppMsg.getMessage(AppMsg.APP_PASSWORD_CHANGE_REQUIRED)): 
                    Promise.reject(AppMsg.getMessage(AppMsg.APP_INVALID_USERNAME_PASSWORD));
            });
          
        } else if (response.status === 500) {   
          // 500 indicates server error. Reload top window and let server handle error.
          window.top.location.reload(true);
          return Promise.reject();
        } else {
          return Promise.reject(AppMsg.getMessage(AppMsg.APP_SYSTEM_ERROR));
        }
    } else {
        return response.json().then(data => {
            return data.url;
        });
    }
}

function changePassword(username, oldPassword, newPassword, confirmNewPassword) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ userName: username, 
                                oldPassword: oldPassword,
                                newPassword: newPassword,
                                confirmNewPassword: confirmNewPassword
                            })
    };

    return fetch('../../p/websignon/tririga-change-pwd', requestOptions).then(handlePasswordChangeResponse);
}

function handlePasswordChangeResponse(response) {
    if (!response.ok) {
        if (response.status !== 500) {
            return response.text().then(text => {
                //First parse out status code in error message.
                let messageIndex = text.indexOf(": ");
                let errorMessage = messageIndex > -1 ? text.slice(messageIndex+2): text;
                return Promise.reject(errorMessage);
            });
            
        } else if (response.status === 500) {   
            // 500 indicates server error. Reload top window and let server handle error.
            window.top.location.reload(true);
            return Promise.reject();
        } else {
            return Promise.reject(AppMsg.getMessage(AppMsg.APP_SYSTEM_ERROR));
        }
    } else {
        //Password changed succesfully
        return Promise.resolve();
    }
}
